import { Environment } from '../../../environment.ts'
import type { OrderCreditCost } from '../../../Generated/OrderCreditCost.ts'
import type { OrderSubmissionPreview } from '../../../Generated/OrderSubmissionPreview.ts'
import type { SequencingPlatformPreview } from '../../../Generated/SequencingPlatformPreview.ts'
import { tracingAxios } from '../../../Repository/Sentry.ts'

/*
 * The read-only previews the classic submit modal (`OrderSubmitModal`) requests inline, restated so the
 * wizard's review step shows the same numbers. Keep in sync with that modal.
 */

const credentials = { withCredentials: true }

export const getOrderCreditCost = async (orderId: string): Promise<OrderCreditCost> =>
  (await tracingAxios.get<OrderCreditCost>(`${Environment.API_URL}/api/orders/${orderId}/credit-cost`, credentials)).data

export const getSubmissionPreview = async (orderId: string): Promise<OrderSubmissionPreview> =>
  (await tracingAxios.get<OrderSubmissionPreview>(`${Environment.API_URL}/api/orders/${orderId}/submission-preview`, credentials)).data

export const getSequencingPlatformPreview = async (orderId: string): Promise<SequencingPlatformPreview> =>
  (await tracingAxios.get<SequencingPlatformPreview>(`${Environment.API_URL}/api/orders/${orderId}/sequencing-platform`, credentials)).data
